import { Route } from '@angular/router';
import { IndexPage } from 'app/modules/well-integrity-planning/pages/index/index.page';
import { PreventiveMaintainancePage } from 'app/modules/well-integrity-planning/pages/pm/pm.page';
import { CorrectiveMaintainancePage } from 'app/modules/well-integrity-planning/pages/cm/cm.page';
import { AdHocPage } from 'app/modules/well-integrity-planning/pages/adhoc/adhoc.page';
import { APRPage } from 'app/modules/well-integrity-planning/pages/apr/apr.page';
import { OtherActivityPage } from 'app/modules/well-integrity-planning/pages/other-activity/other-activity.page';
import { WrsvPage } from 'app/modules/well-integrity-planning/pages/wrsv/wrsv.page';
import { PMDashboardPage } from 'app/modules/well-integrity-planning/pages/pm-dashboard/pm-dashboard.page';
import { FieldSummaryComponent } from 'app/modules/well-integrity-planning/components/field-summary/field-summary.component';
import { StringSummaryComponent } from 'app/modules/well-integrity-planning/components/string-summary/string-summary.component';
import { RemarksComponent } from './pages/remarks/remarks.component';

export const wipDashboardRoutes: Route[] = [
    {
        path: 'well-integrity-planning',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'pm-dashboard',
            },
            {
                path: 'pm-dashboard',
                component: PMDashboardPage,
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'field',
                    },
                    {
                        path: 'field',
                        component: FieldSummaryComponent,
                    },
                    {
                        path: 'string',
                        component: StringSummaryComponent,
                    }
                ]
            },
        ],
    },
];

export const wipDataManagementRoutes: Route[] = [
    {
        path: 'well-integrity-planning',
        component: IndexPage,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'pm',
            },
            {
                path: 'pm',
                component: PreventiveMaintainancePage,
            },
            {
                path: 'cm',
                component: CorrectiveMaintainancePage,
            },
            {
                path: 'adhoc',
                component: AdHocPage,
            },
            {
                path: 'apr',
                component: APRPage,
            },
            {
                path: 'other-activity',
                component: OtherActivityPage,
            },
            {
                path: 'wrsv',
                component: WrsvPage,
            },
            {
                path: 'remarks',
                component: RemarksComponent,
            },
        ],
    },
];

export const wipConfigurationRoutes: Route[] = [
    {
        path: 'well-integrity-planning',
        children: [],
    },
];
